<div class="hmn-background__primary hmn-shared-horiz-bar"></div>
